import type { AnnotationDraft } from '../hooks/useAnnotationDraft.ts';
import type { Tool } from './AnnotationCanvas.tsx';

// The first entry is what a fresh draft draws with (see useAnnotationDraft).
const COLORS = ['#ff3b30', '#ffcc00', '#34c759', '#0a84ff', '#ffffff'];
const TOOLS: { id: Tool; label: string; hint: string }[] = [
  { id: 'pen', label: '✏️', hint: 'Pen' },
  { id: 'line', label: '╱', hint: 'Line' },
  { id: 'arrow', label: '↗', hint: 'Arrow' },
  { id: 'rect', label: '▭', hint: 'Rectangle' },
  { id: 'ellipse', label: '◯', hint: 'Ellipse' },
  { id: 'eraser', label: '⌫', hint: 'Eraser' },
];

interface Props {
  draft: AnnotationDraft;
  /** Throw the drawing away — also tells the room, so peers drop the live preview. */
  onDiscard: () => void;
}

/** Tool, colour and width picker, shown only while drawing is switched on. */
export function DrawToolbar({ draft, onDiscard }: Props): React.JSX.Element {
  return (
    <div className="toolbar">
      <div className="toolbar__group">
        {TOOLS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={draft.tool === t.id ? 'active' : ''}
            onClick={() => draft.setTool(t.id)}
            title={t.hint}
          >
            {t.label}
          </button>
        ))}
        {COLORS.map((c) => (
          <button
            key={c}
            type="button"
            className={`swatch${draft.color === c ? ' active' : ''}`}
            style={{ background: c }}
            onClick={() => draft.setColor(c)}
            title={c}
          />
        ))}
        <input
          type="range"
          min={1}
          max={16}
          value={draft.lineWidth}
          onChange={(e) => draft.setLineWidth(Number(e.target.value))}
          title="Line width"
        />
        <button
          type="button"
          onClick={draft.undo}
          disabled={draft.strokes.length === 0}
          title="Undo (Cmd/Ctrl+Z)"
        >
          ↶
        </button>
        <button type="button" onClick={onDiscard} disabled={draft.strokes.length === 0}>
          Discard
        </button>
      </div>
    </div>
  );
}
